import React, { Component } from 'react';
import { Icon, Popover } from 'antd';

import './InfoBtn.scss';

export default class InfoBtn extends Component {
    render() {
        const { content, onVisibleChange } = this.props;

        return (
            <div className="InfoBtn">
            	<Popover 
                    placement="bottom" 
                    title={null} 
                    content={content} 
                    trigger="click"
                    onVisibleChange={(visible) => onVisibleChange(visible)}
                >
            		<Icon type="info-circle-o" />
            	</Popover>
            </div>
        );
    }
}

InfoBtn.defaultProps = {
	content: null,
    onVisibleChange: () => {}
}


// WEBPACK FOOTER //
// ./src/components/InfoBtn/InfoBtn.js